requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCookieBanner', (delay) => ({
      show: false,
      
      init() {
        setTimeout(() => {
          // 1. API laden
          window.Shopify.loadFeatures(
            [
              {
                name: 'consent-tracking-api',
                version: '0.1',
              }
            ],
            (error) => {
              if (error) {    
                throw error;
              }

              // 2. Prüfen, ob die API geladen ist
              if (!window.Shopify.customerPrivacy) {
                return;
              }

              // 3. Prüfen, ob rechtlich ein Banner nötig ist
              const shouldShow = window.Shopify.customerPrivacy.shouldShowBanner();
              const visitorConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
              const noDecisionMade = visitorConsent.analytics === '';

              if (shouldShow && noDecisionMade) {
                requestAnimationFrame(() => {
                  this.show = true;
                });
              }

              document.dispatchEvent(new CustomEvent("eurus:customer-privacy:loaded"));            
            }
          );
        }, delay * 1000);
      },

      handleAccept() {
        if (window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: true,
              marketing: true,
              preferences: true,
              sale_of_data: true
            }, 
            () => {
              console.log('Full tracking consent captured');
            }
          );
          
          requestAnimationFrame(() => {
            this.show = false;
          });
        }
      },

      handleDecline() {
        if (window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: true,
              marketing: true,
              preferences: true,
              sale_of_data: true
            }, 
            () => {
              console.log('Tracking declined');
            }
          );

          requestAnimationFrame(() => {
            this.show = false;
          });
        }
      }
    }));
  });
});